<template>
  <div>
    <div class="d-flex">
      <div :class="`wd-${disableAdd ? '100p' : '80p'}`">
        <Select
          v-model="selectedTypes"
          filterable
          clearable
          multiple
          @change="typeChange"
          style="width:100%"
        >
          <Option
            :value="t.id"
            v-for="t in types"
            :key="`key_${t.id}`"
            :label="t.s1"
          >
            <b-icon
              v-if="!hideIcon"
              size="1x"
              icon="tag"
              :style="{ color: t.s2 }"
            ></b-icon>
            {{ t.s1 }}
          </Option>
        </Select>
      </div>

      <div
        v-if="
          hasPermission([
            'admin',
            'planadmin',
            'hradmin',
            'archiveadmin',
            'tushaaladmin',
            'crmadmin',
            'contentadmin',
            'webadmin',
          ]) &&
            !disabled &&
            !disableAdd
        "
        class="wd-10px mg-l-5"
      >
        <!-- <Button class="ivu-btn ivu-btn-default" :size="size" @click="showModal()">
          <b-icon icon="plus"></b-icon>
        </Button> -->
        <button
          class="btn btn-outline-light"
          @click="showModal()"
          type="button"
        >
          <b-icon icon="plus"></b-icon>
        </button>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      @hide="cancel()"
      hide-footer
      hide-header
      centered
      body-class="pd-0"
      size="lg"
    >
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          role="button"
          aria-label="Close"
          class="close pos-absolute t-15 r-15"
          @click="cancel()"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <feather type="folder"></feather>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">
              Хавчуурга {{ selectedTypeId == 0 ? "үүсгэх" : "засах" }}
            </h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Тохирох утгуудыг бөглөөд хадгалах дарна уу
            </p>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="wd-40p">
          <div class="pd-10 bg-white bd-b">
            <button
              class="btn btn-outline-light btn-xs btn-block"
              @click="addSub(0)"
            >
              <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Шинэ хавчуурга
              үүсгэх
            </button>
          </div>
          <nav class="nav nav-sidebar tx-13 m-b-md m-t-xs">
            <a
              class="nav-link"
              role="button"
              v-for="(t, i) in types"
              @click="editSub(t.id)"
              :key="i"
              :title="t.field1"
            >
              <!-- <tag-icon v-if="ttle=='Хавчуурга'" :style="{'color': t.s2 }"></tag-icon>
              <folder-icon v-else :style="{'color': t.s2 }"></folder-icon>-->
              <feather type="tag" :style="{ color: t.s2 }"></feather>
              <span class="nav-title">{{ t.s1 }}</span>
            </a>
          </nav>
        </div>
        <div class="wd-60p bd-l">
          <Form v-show="editMode" v-model="locTypeModel" class="pd-10">
            <FormItem label="Хавчуурга" class="m-b-sm">
              <Input v-model="locTypeModel.name" placeholder="___" />
              <!-- {{ locTypeModel }} {{ realKey }} -->
            </FormItem>
            <FormItem label="Өнгө" class="m-b-sm">
              <Select v-model="locTypeModel.value" clearable>
                <Option value="red" label="Улаан">
                  <b-icon size="1x" icon="tag" style="color: red"></b-icon>Улаан
                </Option>
                <Option value="green" label="Ногоон">
                  <b-icon size="1x" icon="tag" style="color: green"></b-icon
                  >Ногоон
                </Option>
                <Option value="orange" label="Шар">
                  <b-icon size="1x" icon="tag" style="color: orange"></b-icon
                  >Шар
                </Option>
                <Option value="blue" label="Хөх">
                  <b-icon size="1x" icon="tag" style="color: blue"></b-icon>Хөх
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Дараалал" class="m-b-sm">
              <InputNumber
                v-model="locTypeModel.ord"
                placeholder="___"
              ></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div class="modal-footer pd-x-20 pd-y-15">
        <button type="button" class="btn btn-white" @click="cancel()">
          Болих
        </button>
        <button v-show="editMode" class="btn btn-primary" @click="saveLocType">
          {{ selectedTypeId == 0 ? "Үүсгэх" : "Засах" }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import lang from "element-ui/lib/locale/lang/mn";
import locale from "element-ui/lib/locale";

// configure language
locale.use(lang);

import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
import "element-ui/lib/theme-chalk/index.css";
import {
  Select,
  //ButtonGroup,
  //Button,
  FormItem,
  InputNumber,
  Input,
  Form,
  Option,
} from "element-ui";

export default {
  components: {
    Select,
    // ButtonGroup,
    //Button,
    FormItem,
    InputNumber,
    Input,
    Form,
    Option,
  },
  name: "locTypeCascader",
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    lkey: {
      type: String,
      default: () => "",
    },
    disableAdd: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    size: {
      type: String,
      default: () => "medium",
    },
    hideIcon: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      list: [],
      selectedTypes: [],
      types: [],
      modalShow: false,
      selectedTypeId: 0,
      locTypeModel: {
        key: null
      },
      editMode: false,
      postedId: 0,
      realkey: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    init() {
      // this.realkey = this.lkey;
      // if (this.lkey.startsWith("sysProjectTag")) {
      //   const splittedArr = this.lkey.split("_");
      //   if (splittedArr.length > 1) {
      //     let prjs = this.$store.state.app.groupDefaultProjects.filter(
      //       (x) => x.objectTypeId == parseInt(splittedArr[1], 10)
      //     );
      //     this.realkey = "sysProjectTag_" + prjs[0].id;
      //   }
      // }

      request({
        params: { key: this.lkey, getParentType: true },
        api: { url: "type/getData", method: "get" },
        store: this.$store,
      }).then((res) => {
        this.types = res.data.types;
        this.selectedTypes = this.ids;
      });
    },
    cascaderModelRecursive(data, cid) {
      this.cascaderSelected.push(cid);
      let pid = data.filter((d) => d.id == cid)[0].parentId;
      if (pid > 0) {
        this.cascaderModelRecursive(data, pid);
      }
    },
    typeChange(e) {
      //console.log(e);
      //let cur= this.projects.filter(p=>p.id===e)[0];
      this.$emit("input", e);
      this.$emit("on-selected", { ids: e });
    },
    showModal() {
      this.modalShow = true;
      this.addSub(0);
    },
    cancel() {
      this.modalShow = false;
      //cancel
    },
    handleTreeSelect(e) {
      //console.log(e);
      if (e != null) {
        this.cascaderSelected = [];
        this.cascaderModelRecursive(this.listFlat, e.id);
        this.cascaderSelected = this.cascaderSelected.reverse();
        this.$emit("input", e.id);
        e.expand = true;

        this.selectedTypeId = e.id;
      } else {
        this.cascaderSelected = [];
        this.$emit("input", 0);
        this.selectedTypeId = 0;
      }
    },
    addSub(id) {
      if (id == 0) this.selectedTypeId = 0;
      this.editMode = true;
      this.locTypeDetail(0, id == 0 ? 0 : id);
    },
    editSub(id) {
      this.editMode = true;
      this.locTypeDetail(id, 0);
    },

    locTypeDetail(id, pid) {
      request({
        params: { id: id, parentId: pid, key: this.realKey },
        api: { url: "Type/GetInheritedDetail", method: "get" },
        store: this.$store,
      }).then((res) => {
        
        this.locTypeModel = res.data;
        this.locTypeModel.key= this.lkey;
      });
    },
    saveLocType() {
      request({
        data: { model: this.locTypeModel },
        api: { url: "Type/PostType", method: "post" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.editMode = false;
          this.postedId = res.data.typeId;
          this.selectedTypeId = res.data.typeId;
          this.init();
        }
      });
    },
  },
};
</script>
